import React, { PureComponent, ReactNode } from "react";
import "./InstrumentCapoChoices.css";
import LabelledCheckbox from "../theme_reuse/LabelledCheckbox";

interface Props {
  capoPosition: number;
  isTabRelative: boolean;
  onChangePosition: (cp: number) => void;
  onToggleRelativeTabNumbers: () => void;
}
interface State {}

class InstrumentCapoPositionChoice extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  handleChangePosition = (e: React.ChangeEvent<HTMLInputElement>) => {
    const num = Number.parseInt(e.target.value);
    if (Number.isInteger(num) && num > -1 && num < 12) {
      this.props.onChangePosition(num);
    } else if (e.target.value === "") {
      this.props.onChangePosition(0);
    }
  };

  handleToggleRelative = () => {
    this.props.onToggleRelativeTabNumbers();
  };

  render(): ReactNode {
    const { capoPosition, isTabRelative } = this.props;
    return (
      <>
        <span className="capo-position-choice">
          <label htmlFor="capo-pos-input">Capo: </label>
          <input
            id="capo-pos-input"
            name="capo-pos-input"
            type="number"
            max="11"
            min="0"
            value={capoPosition}
            onChange={this.handleChangePosition}
          ></input>
        </span>
        {capoPosition > 0 && (
          <span className="capo-relativize-choice">
            <LabelledCheckbox
              checkboxUniqueId="cb-relativize"
              isChecked={isTabRelative}
              labelText={"Relative?"}
              onChange={this.handleToggleRelative}
            />
          </span>
        )}
      </>
    );
  }
}

export default InstrumentCapoPositionChoice;
